import React, { forwardRef } from 'react';
import { JourneyParams, Rate } from 'shared-types/Common';
import styled from 'styled-components';
import { RatesListing } from './RatesListing';
import { NoRatesAvailable } from '../NoRatesAvailable';
import { Spinner } from '@common/components';

const Container = styled.div`
  position: relative;
  min-height: 220px;
`;

type RatesProps = {
  rates: Rate[];
  roomId: string;
  journeyParams: JourneyParams;
  fetching: boolean;
  roomIdsInBasket?: string[];
};

const Rates = ({ rates, roomId, journeyParams, fetching, roomIdsInBasket }: RatesProps, ref) => (
  <Container>
    {!fetching && (
      <>
        {rates && rates.length > 0 && (
          <>
            <div ref={ref} />
            <RatesListing
              roomId={roomId}
              datePartyData={journeyParams}
              rates={rates}
              roomIdsInBasket={roomIdsInBasket}
            />
          </>
        )}
        {(!rates || !rates.length) && <NoRatesAvailable />}
      </>
    )}
    <Spinner isActive={fetching} showDelayMessage isLocal={true} />
  </Container>
);

export default forwardRef(Rates);
